// extracted by mini-css-extract-plugin
export default {"paymentButton":"PaymentMethodWallet_paymentButton__uaGLI"};